import type { FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import Badge from '@segment/matcha/components/Badge'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CardBase, * as Card from '@segment/matcha/recipes/Card'

import dataPrivacyPng from './assets/DataPrivacy.png'
import identityResolutionPng from './assets/IdentityResolution.png'

const data = [
  {
    image: identityResolutionPng,
    badge: `eBook`,
    title: `Identity Resolution: A guide to the post-cookie world`,
    description: `With the imminent death of the cookie, companies must invest in a first-party identity resolution solution to stay ahead of the pack.`,
    button: `Download the guide`,
    url: `https://learn.segment.com/identity-resolution/`,
  },
  {
    image: dataPrivacyPng,
    badge: `eBook`,
    title: `Data Privacy: A practical guide to data privacy planning `,
    description: `Confused by the rapidly evolving data privacy landscape? In this guide you’ll learn more about data privacy and key considerations for GDPR, CCPA, Schrems II, browser privacy changes, mobile ad IDs, and more.`,
    button: `Download the guide`,
    url: `https://learn.segment.com/data-privacy-ebook/`,
  },
]

const Guides: FC = () => {
  return (
    <SectionBase variant="noCopy">
      <Section.Contents>
        <StyledColumnTrack
          overrides={{
            md: 2,
          }}
        >
          {data.map(({ image, badge, title, description, button, url }, key) => (
            <CardBase key={key} href={url}>
              <StyledCardImage alt={`Illustration: ${title}`} src={image} variant="fill" />
              <Card.Body>
                <Card.Accessories>
                  <Card.AccessoriesRow>
                    <Badge variant="outlined">{badge}</Badge>
                  </Card.AccessoriesRow>
                </Card.Accessories>
                <Card.Copy>
                  <Card.Headline tag="h3">{title}</Card.Headline>
                  <Card.Description>{description}</Card.Description>
                </Card.Copy>
                <Card.Action alignment="left">
                  <ButtonText iconEnd={ChevronRightIcon}>{button}</ButtonText>
                </Card.Action>
              </Card.Body>
            </CardBase>
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 800px;
  margin: 0 auto;
`

const StyledCardImage = styled(Card.Image)`
  height: 216px;
`

export default Guides
